import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AllEmployeeAddPopup from "../../../components/modelpopup/AllEmployeeAddPopup";
import DeleteModal from "../../../components/modelpopup/DeleteModal";
import EmployeeList from "./EmployeeList";
import { RefreshProvider } from "../../../context/RefreshContext";
import api from "../../../api/axios";

const AllEmployee = () => {
  const [employeeData, setEmployeeData] = useState([]);

  useEffect(() => {
    api
      .get(`employees/`)
      .then((res) => setEmployeeData(res.data))
      .catch((err) => {
        console.log(err);
      });
  }, []);

  return (
    <div>
      <RefreshProvider>
        <EmployeeList />
        <AllEmployeeAddPopup />
        <DeleteModal Name="Deactivate Employee" />
      </RefreshProvider>

      {/* Delete Modal */}
    </div>
  );
};

export default AllEmployee;
